import {loadHtmlScript} from "../utils/loadHtmlScript";

export const loadAdDoorPixel = async () => {
    return loadHtmlScript('https://pubtags.addoor.net/lib/contags/contags.js')
}